var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"csContainer"}},[_c('el-button',{staticClass:"getModel",attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.getModel()}}},[_vm._v("高亮模型")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }